import React from "react";
import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";


const AvtLineChart = ({sditems,saleitems,label}) => {
  
  //const labels = sditems;
   const data = {
    labels: sditems,
    datasets: [ {
         label: label,
         backgroundColor: "rgb(255, 99, 132)",
         borderColor: "rgba(255, 99, 132, 0.5)",
         data: saleitems, 
    }, ],
  };

 
  return (
    <div style={{ padding:"20px"}}>
      <Line data={data} />
    
    </div>
  );
};

export default AvtLineChart;

